const statementField = {
  name: "statement",
  label: "hotel.booking.wiz_payment.statement",
  sizeLabel: "text-3xl mb-6",
};

const amountField = {
  name: "amount",
  label: "hotel.booking.wiz_payment.amount",
  type: "number",
  specialCharacters: true,
};

const voucherField = {
  name: "voucher",
  label: "hotel.booking.wiz_payment.voucher",
  type: "char",
};

const notesField = {
  name: "notes",
  label: "hotel.booking.wiz_payment.notes",
  type: "text",
};

export { notesField, statementField, amountField, voucherField };
